import { ContainerModule, interfaces } from 'inversify';
import { FreeAccessService, IFreeAccessService } from './freeAccess.service';
import { FreeAccessStore, IFreeAccessStore } from './freeAccess.store';
import { FreeAccessApiService, IFreeAccessApiService } from './freeAccessApi.service';
import { FreeAccessImagesQueueService, IFreeAccessImagesQueueService } from './freeAccessImagesQueue.service';

export const freeAccessModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IFreeAccessStore.$).to(FreeAccessStore).inSingletonScope();
  bind(IFreeAccessApiService.$).to(FreeAccessApiService).inTransientScope();
  bind(IFreeAccessService.$).to(FreeAccessService).inSingletonScope();
  bind(IFreeAccessImagesQueueService.$).to(FreeAccessImagesQueueService).inTransientScope();
});
